export default __webpack_public_path__ + "static/media/event.fbc98018.svg";